module.exports = __webpack_public_path__ + "static/media/team-mosaic-02.3bfbd5ff.jpg";